const BaseDataStore = require("./BaseDataStore.js");
const ApplicationContext = require("../shared/config/ApplicationContext.js");
const RegionUtil = require("../shared/util/RegionUtil.js");
const SessionRecovery = require("./SessionRecovery.js");

class BrowserDataStore extends BaseDataStore {
    /**
     * 
     * @param {String} url something like: /package/:id, /library/:id, /packages, 
     */
    getData(url, handleError) {
        const contentUrl = `${RegionUtil.getRegionServer()}/${ApplicationContext.contentServer.tenant}${url}`;

        const options = {
            credentials: "include"
        };

        const doFetch = () => fetch(contentUrl, options);

        return SessionRecovery.withSessionRecovery(ApplicationContext.getCurrentRegion(), doFetch)
            .then(res => {
                if (res.status == 200) {
                    return res.json()
                } else {
                    handleError(res, "retrieve page data");
                    throw err;
                }
            })
            .catch(err=>{
                handleError(null, "connect to server",  "Check your connection and try again.");
                throw err;
            })
    }

    doAuth(nextUrl = "/id-username/libraries") {
        var redirectUrl =`${window.location.origin}/checkLoginSuccess?${nextUrl}`;
        var loginURL = `${ApplicationContext.usContentUrl()}/actions/login?tenant=circuits&redirect=${redirectUrl}`
        window.location = loginURL;
    }

    checkUserLoginThen(nextUrl) {
        return this.getUserInfo().then((succeed) => {
            if (succeed) {
                return succeed;
            } else {
                this.doAuth(nextUrl);
            }
        })
    }

    getUserInfo(handleError) {
        var userInfoUrl = `${ApplicationContext.usContentUrl()}/actions/userUsageInfoFromSession`;
        var options = {
            credentials: "include"
        };
        return fetch(userInfoUrl, options)
            .then(res => {
                if (res.status == 401){
                    // this will prompt the sign-in page,
                    // no need to throw an error
                    return false;
                }
                else if (res.status == 200) {
                    return res.json().then((data) => {
                        ApplicationContext.setUserData(data);
                        return this.bootstrapRegionalSessions()
                            .then(() => {
                                return true;
                            })
                    })
                } else {
                    handleError(res, "retrieve user data");
                }
            })
            .catch(err=>{
                handleError(null, "connect to server",  "Check your connection and try again.");
            })
    }

    bootstrapRegionalSessions() {
        return RegionUtil.getRegions().then(regions => {
            const homeRegion = ApplicationContext.getHomeRegion();

            const targets = Object.keys(regions || {}).filter(r => r !== homeRegion);
            if (targets.length === 0) return;

            return Promise.allSettled(targets.map(regionId => {
                return SessionRecovery.establishRegionCSSession(regionId).then(res => {
                    if (!res.ok) {
                        console.warn(`Regional session bootstrap failed for ${regionId}: ${res.status}`);
                    }
                    return res;
                }).catch(err => {
                    console.warn(`Regional session bootstrap error for ${regionId}`, err);
                });
            }));
        });
    }

    logoutUser() {
        ApplicationContext.setUserData(undefined);

        const { contentServer: { tenant } } = ApplicationContext;
        const homeRegion = ApplicationContext.getHomeRegion();

        RegionUtil.getRegions().then(regions => {
            const remoteRegionLogouts = Object.keys(regions || {})
                .filter(r => r !== homeRegion)
                .map(regionId => {
                    const regionUrl = regions[regionId];
                    return fetch(`${regionUrl}/${tenant}/actions/logout`, {
                        credentials: "include"
                    }).catch(err => {
                        console.warn(`Regional logout failed for ${regionId}`, err);
                    });
                });
            return Promise.allSettled(remoteRegionLogouts);
        }).finally(() => {
            const logoutUrl = `${ApplicationContext.usContentUrl()}/actions/logout?redirect=${window.location.origin}`;
            window.location.assign(logoutUrl);
        });
    }
}

module.exports = BrowserDataStore;
